import { convertToDate, isEmptyObject as isEmpty } from '@jfs/utils'
import { flow, getType, Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'
import { getUPIIntentApi, getUPIIntentRequest } from '../../network/api/getUPIIntentApi'
import { findBestMatch, MessageTypes } from '../../utils'
import { PAYMENT_MODE_SUBTYPES } from '../../utils/constants'
import { errorMessage } from '../../utils/string'
import { RootStore } from '../store'
import { Amount } from './Amount'
import { Bank, BankType } from './Bank'
import { Bill } from './Bill'
import { Card, CardType } from './Card'
import { CardlessEMI, CardlessEMIType } from './CardlessEMI'
import { Client } from './Client'
import { ConvenienceFee } from './ConvenienceFee'
import { EMI, EMIType } from './EMI'
import { FoodCard, FoodCardType } from './FoodCard'
import { JioFinanceHub, JioFinanceHubType } from './JioPayFinanceHub'
import { NewToCredit, NewToCreditType } from './NewToCredit'
import { PayLater, PayLaterType } from './PayLater'
import { SubscriptionType } from './Subscription'
import { UPI, UPIType } from './UPI'
import { Wallet, WalletType } from './Wallet'

const { REACT_APP_URL = '', REACT_APP_ENDPOINT = '' } = process.env

const Tax = types.model('Tax', {
  igstpercentage: types.optional(types.string, ''),
  ugstpercentage: types.optional(types.string, ''),
  sgstpercentage: types.optional(types.string, ''),
  cgstpercentage: types.optional(types.string, ''),
  serviceTaxAmt4: types.optional(types.string, ''),
  serviceTaxAmt3: types.optional(types.string, ''),
  serviceTaxAmt2: types.optional(types.string, ''),
  serviceTaxAmt1: types.optional(types.string, ''),
  totalServiceTax: types.optional(types.string, ''),
})

const SplitTxn = types.model('SplitTxn', {
  splitTxn: types.optional(types.boolean, false), //txn
  splitdetailswithrrn: types.optional(types.string, ''),
  splitdetails: types.optional(types.string, ''),
})

const CollectLink = types.model('CollectLink', {
  collectLinkRequest: types.optional(types.string, ''),
  collLinkMerchantId: types.optional(types.string, ''),
})

const LoadTxn = types.model('LoadTxn', {
  apiLoadAmt: types.optional(types.string, ''),
  loadamount: types.optional(types.string, ''),
  loadMoneyAsync: types.optional(types.boolean, false),
  tomobile: types.optional(types.string, ''),
})

const Id = types.model('Id', {
  id: types.optional(types.string, ''),
  intentId: types.optional(types.string, ''),
  checksum: types.optional(types.string, ''),
  paymentid: types.optional(types.string, ''),
  extref: types.optional(types.string, ''),
  intref: types.optional(types.string, ''),
  txntstoken: types.optional(types.string, ''),
  token: types.optional(types.string, ''),
  orgextref: types.optional(types.string, ''),
  invoiceno: types.optional(types.string, ''),
  application: types.optional(types.number, 0),
  appaccesstoken: types.optional(types.string, ''),
  appidtoken: types.optional(types.string, ''),
  preProcessId: types.optional(types.string, ''),
})

const Udf = types.model('Udf', {
  udf1: types.optional(types.string, ''),
  udf2: types.optional(types.string, ''),
  udf3: types.optional(types.string, ''),
  udf4: types.optional(types.string, ''),
  udf5: types.optional(types.string, ''),
})

const Retry = types.model('Retry', {
  count: types.optional(types.number, 0), //failed count
  prevResponse: types.optional(types.string, ''), // previousTxnResponse
  timeout: types.optional(types.string, '600'),
  interval: types.optional(types.string, ''),
})

const TxnMeta = types.model('TxnMeta', {
  method: types.optional(types.string, ''),
  returnUrl: types.optional(types.string, ''),
  contentType: types.optional(types.string, ''),
  payLoad: types.optional(types.frozen(), {}),
  redirectHtml: types.optional(types.string, ''),
})

const InitiatingEntity = types.model('InitiatingEntity', {
  entityId: types.optional(types.number, 0),
  callbackUrl: types.optional(types.string, ''),
  returnUrl: types.optional(types.string, ''),
  timeStamp: types.optional(types.string, ''),
})

const Payer = types.model('Payer', {
  number: types.optional(types.string, ''),
  countryCode: types.optional(types.string, ''),
  type: types.optional(types.number, 0),
  gstIn: types.optional(types.string, ''),
  gstInvoice: types.optional(types.string, ''),
  gstConsent: types.optional(types.string, ''),
  pan: types.optional(types.string, ''),
})

const Payee = types.model('Payee', {
  terminalId: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  mcc: types.optional(types.string, ''),
  type: types.optional(types.number, 0),
  userId: types.optional(types.string, ''),
  mobile: types.optional(types.string, ''),
})

const Mandate = types.model('Mandate', {
  tillDate: types.optional(types.string, ''),
  frequency: types.optional(types.string, ''),
})

const LAPNB = types.model('LAPNB', {
  channel: types.optional(types.string, ''),
  allwcustspinpchs: types.optional(types.string, ''),
  txntype: types.optional(types.string, ''),
  uitype: types.optional(types.string, ''),
  orgextref: types.optional(types.string, ''),
  orgintref: types.optional(types.string, ''),
  sourceId: types.optional(types.string, ''),

  paymenttype: types.optional(types.string, ''),
  finalpaymodes: types.optional(types.string, ''),
  isClickable: types.optional(types.string, ''),
  timestamp: types.optional(types.string, ''),
  expMon: types.optional(types.string, ''),
  expYr: types.optional(types.string, ''),
  clientId: types.optional(types.number, 0),
  checksum: types.optional(types.string, ''),
  merchantid: types.optional(types.number, 0),
  extref: types.optional(types.string, ''),
  intref: types.optional(types.string, ''),
  cardTrustedMerchants: types.optional(types.string, ''),
  enableForCommonSavedCard: types.optional(types.string, ''),
  loadAmount: types.optional(types.string, ''),
  pan: types.optional(types.string, ''),
  cardType: types.optional(types.string, ''),
  cardScheme: types.optional(types.string, ''),
  nickName: types.optional(types.string, ''),
})

const Product = types.model('Product', {
  productId: types.optional(types.string, ''),
  productValidationKey: types.optional(types.string, ''),
  productValidationValue: types.optional(types.string, ''),
  transactionAmount: types.optional(types.string, ''),
  categoryId1: types.optional(types.string, ''),
  categoryId2: types.optional(types.string, ''),
  categoryId3: types.optional(types.string, ''),
  categoryId4: types.optional(types.string, ''),
  categoryId5: types.optional(types.string, ''),
})

const AppliedOffer = types.model('AppliedOffer', {
  instantDiscountAmount: types.optional(types.number, 0),
  offerCode: types.optional(types.string, ''),
  offerReferenceId: types.optional(types.string, ''),
  transactionAmount: types.optional(types.number, 0),
  cashBackAmount: types.optional(types.number, 0),
})

const MetaData = types.model('MetaData', {
  product: types.array(Product),
})

const ConvenienceFeeList = types.model('ConvenienceFeeList', {
  nb: types.array(ConvenienceFee),
  nbOffers: types.array(ConvenienceFee),
  corpNb: types.array(ConvenienceFee),
  corpNbOffers: types.array(ConvenienceFee),
  wallet: types.array(ConvenienceFee),
  walletOffers: types.array(ConvenienceFee),
  card: types.array(ConvenienceFee),
  cardOffers: types.array(ConvenienceFee),
})

const Transaction = types
  .model('Trasacation', {
    id: types.optional(Id, {}),
    timestamp: types.optional(types.string, ''),
    txntype: types.optional(types.string, 'PURCHASE'),
    bill: types.optional(Bill, {}),
    paymentMethod: types.array(
      types.union(Wallet, Card, UPI, Bank, PayLater, EMI, CardlessEMI, FoodCard, NewToCredit, JioFinanceHub),
    ),
    amount: types.optional(Amount, {}),
    paymentStatus: types.optional(types.string, ''),
    split: types.optional(SplitTxn, {}),
    tax: types.optional(Tax, {}),
    collect: types.optional(CollectLink, {}),
    loadTxn: types.optional(LoadTxn, {}),
    udf: types.optional(Udf, {}),
    retry: types.optional(Retry, {}),
    txnMeta: types.maybe(TxnMeta),
    client: types.optional(Client, {}),
    productdescription: types.optional(types.string, ''),
    descr: types.optional(types.string, ''),
    otpErrorMsg: types.optional(types.string, ''),
    addionaltags: types.optional(types.string, ''),
    isLoadAndPay: types.optional(types.boolean, false),
    isDirectPayment: types.optional(types.boolean, false),
    isLoadAndPayApiCompleted: types.optional(types.boolean, false),
    methodType: types.optional(types.number, 0),
    mode: types.optional(types.number, 0),
    initiatingEntity: types.optional(InitiatingEntity, {}),
    payer: types.optional(Payer, {}),
    payee: types.optional(Payee, {}),
    // used for?
    bankmsg: types.optional(types.string, ''), // ??
    mandate: types.optional(Mandate, {}),
    txnStatus: types.optional(types.string, ''),
    product: types.optional(Product, {}),
    lAPNB: types.optional(LAPNB, {}),
    // selectedOfferType: types.array(types.string),
    isOfferApplied: types.optional(types.boolean, false),
    offerCode: types.optional(types.string, ''),
    selectedOfferPMSubType: types.optional(types.number, 0),
    selectedOfferPMType: types.optional(types.number, 0),
    metadata: types.optional(MetaData, {}),
    appliedOffer: types.optional(AppliedOffer, {}),
    isValidOffer: types.optional(types.boolean, false),
    cvv: types.optional(types.string, ''),
    token: types.optional(types.string, ''),
    bankId: types.optional(types.string, ''),
    expiry: types.optional(types.string, ''),
    subscriptionError: types.optional(types.string, ''),
    remarks: types.optional(types.string, ''),
    upiIntent: types.optional(types.string, ''),
    statementDescriptor: types.optional(types.string, 'e-Mandates'),
    convenienceFee: types.optional(ConvenienceFee, {}),
    convenienceFeeList: types.optional(ConvenienceFeeList, {}),
    callIntentStatusApi: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    isConFeeAvailable(paymentSubType: number, isOfferApplied: boolean = false) {
      switch (paymentSubType) {
        case PAYMENT_MODE_SUBTYPES.CARD:
          if (isOfferApplied) {
            return self.convenienceFeeList.cardOffers?.length > 0 ? true : false
          } else {
            return self.convenienceFeeList.card?.length > 0 ? true : false
          }
        case PAYMENT_MODE_SUBTYPES.NB:
          if (isOfferApplied) {
            return self.convenienceFeeList.nbOffers?.length > 0 ? true : false
          } else {
            return self.convenienceFeeList.nb?.length > 0 ? true : false
          }
        case PAYMENT_MODE_SUBTYPES.WALLET:
          if (isOfferApplied) {
            return self.convenienceFeeList.walletOffers?.length > 0 ? true : false
          } else {
            return self.convenienceFeeList.wallet?.length > 0 ? true : false
          }
        case PAYMENT_MODE_SUBTYPES.CORP_NB:
          if (isOfferApplied) {
            return self.convenienceFeeList.corpNbOffers?.length > 0 ? true : false
          } else {
            return self.convenienceFeeList.corpNb?.length > 0 ? true : false
          }
        default:
          if (isOfferApplied) {
            return self.convenienceFeeList.cardOffers?.length > 0 ? true : false
          } else {
            return self.convenienceFeeList.card?.length > 0 ? true : false
          }
      }
    },
    getConvenienceFee(
      paymentSubType: number,
      isOfferApplied: boolean,
      filterItem: string,
      filterItemTwo: string = '',
      isDomestic: boolean = true,
      product?: string,
    ) {
      switch (paymentSubType) {
        case PAYMENT_MODE_SUBTYPES.CARD:
          const searchItem = {
            type: filterItem,
            scheme: filterItemTwo,
            isDomestic: String(isDomestic),
            product,
          }
          const priorityList = ['isDomestic', 'product', 'scheme', 'type']
          if (isOfferApplied) {
            const cardOfferConvenienceFee = findBestMatch(
              searchItem,
              self.convenienceFeeList.cardOffers,
              priorityList,
              '*',
              'card',
            )
            return cardOfferConvenienceFee
          } else {
            const cardConvenienceFee = findBestMatch(
              searchItem,
              self.convenienceFeeList.card,
              priorityList,
              '*',
              'card',
            )
            return cardConvenienceFee
          }
        case PAYMENT_MODE_SUBTYPES.NB:
          if (isOfferApplied) {
            const [nbOfferConvenienceFee] = self.convenienceFeeList.nbOffers.filter(
              (convenienceFee) => filterItem === convenienceFee.bankId,
            )
            return nbOfferConvenienceFee
          } else {
            const [nbConvenienceFee] = self.convenienceFeeList.nb.filter(
              (convenienceFee) => filterItem === convenienceFee.bankId,
            )
            console.log('getConvenienceFee called1', nbConvenienceFee)
            return nbConvenienceFee
          }
        case PAYMENT_MODE_SUBTYPES.WALLET:
          if (isOfferApplied) {
            const [walletOfferConvenienceFee] = self.convenienceFeeList.walletOffers.filter(
              (convenienceFee) => filterItem === convenienceFee.bankId,
            )
            return walletOfferConvenienceFee
          } else {
            const [walletConvenienceFee] = self.convenienceFeeList.wallet.filter(
              (convenienceFee) => filterItem === convenienceFee.bankId,
            )
            return walletConvenienceFee
          }
        default:
          if (isOfferApplied) {
            const [cardOfferConvenienceFee] = self.convenienceFeeList.cardOffers.filter(
              (convenienceFee) => filterItem === convenienceFee.card.type,
            )
            return cardOfferConvenienceFee
          } else {
            const [cardConvenienceFee] = self.convenienceFeeList.card.filter(
              (convenienceFee) => filterItem === convenienceFee.card.type,
            )
            return cardConvenienceFee
          }
      }
    },
    updateSubscriptionError(error: string) {
      self.subscriptionError = error
    },
    updateSelectedOfferType(offerTypes: any) {
      offerTypes.forEach((item: any) => {
        console.log('item', item)
        //self.selectedOfferType.push(item)
      })
    },
    updateTransactionData(parms: any) {
      self.productdescription = parms?.productdescription
      self.descr = parms?.descr
      self.addionaltags = parms?.addionaltags
      self.bankmsg = parms?.bankmsg
      self.timestamp = parms?.timestamp

      self.id.checksum = parms?.checksum
      self.id.paymentid = parms?.paymentid
      self.id.extref = parms?.extref
      self.id.intref = parms?.intref
      self.id.txntstoken = parms?.txntstoken
      self.id.token = parms?.token
      self.id.orgextref = parms?.orgextref
      self.id.invoiceno = parms?.invoiceno

      self.loadTxn.apiLoadAmt = parms?.apiLoadAmt
      self.loadTxn.loadamount = parms?.loadamount
      self.loadTxn.loadMoneyAsync = Boolean(parms?.loadMoneyAsync ?? false)
      self.loadTxn.tomobile = parms?.tomobile

      self.amount.grossAmount = parms?.amount
      self.amount.currency = parms?.currency
      self.amount.feeamount = parms?.feeamount
      self.amount.netAmount = parms?.netAmount
      self.amount.conFee = parms?.conFee

      self.tax.igstpercentage = parms?.igstpercentage
      self.tax.ugstpercentage = parms?.ugstpercentage
      self.tax.sgstpercentage = parms?.sgstpercentage
      self.tax.cgstpercentage = parms?.cgstpercentage
      self.tax.serviceTaxAmt4 = parms?.serviceTaxAmt4
      self.tax.serviceTaxAmt3 = parms?.serviceTaxAmt3
      self.tax.serviceTaxAmt2 = parms?.serviceTaxAmt2
      self.tax.serviceTaxAmt1 = parms?.serviceTaxAmt1
      self.tax.totalServiceTax = parms?.totalServiceTax

      self.bill.billid = parms?.billid
      self.bill.billerid = parms?.billerid
      self.bill.billername = parms?.billername
      self.bill.billdetail = parms?.billdetail
      self.bill.authenticator1 = parms?.authenticator1
      self.bill.authenticator2 = parms?.authenticator2
      self.bill.authenticator3 = parms?.authenticator3
      self.bill.authenticator4 = parms?.authenticator4
      self.bill.authenticator5 = parms?.authenticator5
      self.bill.authenticator6 = parms?.authenticator6
      self.bill.authenticator7 = parms?.authenticator7

      self.bill.autoPay.si_flag = parms?.si_flag
      self.bill.autoPay.si_product_id = parms?.si_product_id
      self.bill.autoPay.si_expiry_date = parms?.si_expiry_date
      self.bill.autoPay.si_customer_id = parms?.si_customer_id
      self.bill.autoPay.si_frequency = parms?.si_frequency
      self.bill.autoPay.si_product_desc = parms?.si_product_desc
      self.bill.autoPay.si_amount_type = parms?.si_amount_type
      self.bill.autoPay.si_max_amount = parms?.si_max_amount
      self.bill.autoPay.isAutoSipTxn = parms?.isAutoSipTxn

      //
      self.udf.udf1 = parms?.udf1
      self.udf.udf2 = parms?.udf2
      self.udf.udf3 = parms?.udf3
      self.udf.udf4 = parms?.udf4
      self.udf.udf5 = parms?.udf5

      self.client.clientId = Number(parms?.clientId ?? 0)
      self.client.ipaddress = parms?.ipaddress
      self.client.macaddress = parms?.macaddress
      self.client.deviceid = parms?.deviceid
      self.client.devicetype = parms?.devicetype
      self.client.deviceInfo = parms?.deviceInfo

      self.retry.count = parms?.failedcount

      self.collect.collectLinkRequest = parms?.collectLinkRequest
      self.collect.collLinkMerchantId = parms?.collLinkMerchantId

      self.split.splitTxn = parms?.splitTxn
      self.split.splitdetailswithrrn = parms?.splitdetailswithrrn
      self.split.splitdetails = parms?.splitdetails
    },
    updateIsValidOffer(isValid: boolean) {
      self.isValidOffer = isValid
    },
    getPaymentType() {
      const paymentType = self.paymentMethod[0]?.paymentType
      return paymentType
    },
    updateLoadAnPayData(params: any) {
      self.lAPNB.allwcustspinpchs = params.allwcustspinpchs
      self.lAPNB.uitype = params.uitype
      self.lAPNB.orgextref = params.orgextref
      self.lAPNB.paymenttype = params.paymentType
      self.lAPNB.finalpaymodes = params.finalpaymodes
      self.lAPNB.isClickable = params.isClickable
      self.lAPNB.checksum = params.checksum
      self.lAPNB.extref = params.extref
      self.lAPNB.intref = params.intref
      self.lAPNB.cardTrustedMerchants = params.cardTrustedMerchants
      self.lAPNB.enableForCommonSavedCard = params.enableForCommonSavedCard
      self.lAPNB.loadAmount = params.loadAmount
    },
    updateChecksumData(params: any) {
      const { checksum, extRef, timeStamp, txntype, amount } = params
      self.id.checksum = checksum
      self.id.extref = extRef
      self.timestamp = timeStamp
      self.txntype = txntype
      self.amount.grossAmount = amount
      self.amount.netAmount = amount
    },
    addPaymentMethod(
      payInstrument: CardType | WalletType | UPIType | BankType | CardlessEMIType | NewToCreditType | JioFinanceHubType,
    ): void {
      const paymentType = payInstrument.paymentType
      self.paymentMethod.length = 0
      if (paymentType === 'Card') {
        self.paymentMethod.push(Card.create(payInstrument as CardType))
      } else if (paymentType === 'Wallet') {
        self.paymentMethod.push(Wallet.create(payInstrument as WalletType))
      } else if (paymentType === 'Bank' || paymentType === 'CpNetBank') {
        self.paymentMethod.push(Bank.create(payInstrument as BankType))
      } else if (paymentType === 'UPI') {
        self.paymentMethod.push(UPI.create(payInstrument as UPIType))
      } else if (paymentType === 'EMI') {
        self.paymentMethod.push(EMI.create(payInstrument as EMIType))
      } else if (paymentType === 'CardlessEMI') {
        self.paymentMethod.push(CardlessEMI.create(payInstrument as CardlessEMIType))
      } else if (paymentType === 'PayLater') {
        self.paymentMethod.push(PayLater.create(payInstrument as PayLaterType))
      } else if (paymentType === 'FoodCard') {
        //TODO: Check
        self.paymentMethod.push(FoodCard.create(payInstrument as FoodCardType))
      } else if (paymentType === 'NewToCredit') {
        self.paymentMethod.push(NewToCredit.create(payInstrument as BankType))
      } else if (paymentType === 'JioFinanceHub') {
        self.paymentMethod.push(JioFinanceHub.create(payInstrument as JioFinanceHubType))
      }
    },
    updatePaymentMethod(paymentType: string, subscription: SubscriptionType) {
      if (paymentType === 'Card') {
        const cardIndex = self.paymentMethod.findIndex((item) => getType(item).name === 'Card')
        const card: any = self.paymentMethod[cardIndex]
        const cardData = {
          cvv: card.cvv,
          expDate: card.expDate,
          expmon: card.expmon,
          expyr: card.expyr,
          id: card.id,
          isSave: card.isSave,
          number: card.number,
          ownerName: card.ownerName,
          paymentType: card.paymentType,
          scheme: card.scheme,
          subType: card.subType,
          emiBankId: card.emiBankId,
          isEMIEligible: card.isEMIEligible,
          token: card.token,
          offerEligibility: card.offerEligibility,
          isSubscription: true,
          subscription: {
            blockFund: subscription.blockFund,
            consentId: subscription.consentId,
            frequency: subscription.frequency,
            revocable: subscription.revocable,
            ruleAmount: subscription.ruleAmount,
            ruleAmountValue: subscription.ruleAmountValue,
            ruleRecurrence: subscription.ruleRecurrence,
            ruleRecurrenceValue: subscription.ruleRecurrenceValue,
            scheduled: subscription.scheduled,
            scheduledAt: subscription.scheduledAt,
            scheduledEnd: subscription.scheduledEnd,
            share: subscription.share,
            type: subscription.type,
            allowPurchase: subscription.allowPurchase,
          },
          type: 'CREDITCARD',
        } as CardType
        self.paymentMethod.remove(self.paymentMethod[cardIndex])
        self.paymentMethod.push(Card.create(cardData))
      } else if (paymentType === 'UPI') {
        const upiIndex = self.paymentMethod.findIndex((item) => getType(item).name === 'UPI')
        const upi: any = self.paymentMethod[upiIndex]
        const upiData = {
          id: upi.id,
          name: upi.name,
          vpa: upi.vpa,
          balance: upi.balance,
          logo: upi.logo,
          isSave: upi.isSave,
          isSubscription: true,
          subscription: {
            blockFund: subscription.blockFund,
            consentId: subscription.consentId,
            frequency: subscription.frequency,
            revocable: subscription.revocable,
            ruleAmount: subscription.ruleAmount,
            ruleAmountValue: subscription.ruleAmountValue,
            ruleRecurrence: subscription.ruleRecurrence,
            ruleRecurrenceValue: subscription.ruleRecurrenceValue,
            scheduled: subscription.scheduled,
            scheduledAt: subscription.scheduledAt,
            scheduledEnd: subscription.scheduledEnd,
            share: subscription.share,
            type: subscription.type,
            allowPurchase: subscription.allowPurchase,
          },
          paymentType: upi.paymentType,
        } as UPIType
        self.paymentMethod.remove(self.paymentMethod[upiIndex])
        self.paymentMethod.push(UPI.create(upiData))
      }
    },
    updateCardDetails(card: CardType): void {
      const cardIndex = self.paymentMethod.findIndex((item) => getType(item).name === 'Card')
      const cardData = {
        ...self.paymentMethod[cardIndex],
        scheme: card.scheme,
        type: card.type,
      } as CardType
      self.paymentMethod.remove(self.paymentMethod[cardIndex])
      self.paymentMethod.push(Card.create(cardData))
    },
    updateSaveCards(card: CardType): void {
      const cardIndex = self.paymentMethod.findIndex((item) => getType(item).name === 'Card')
      const cardData = {
        ...self.paymentMethod[cardIndex],
        token: card.token,
      } as CardType
      self.paymentMethod.push(Card.create(cardData))
    },
    updateIsLoadAndPay(isLoadAndPay: boolean): void {
      self.isLoadAndPay = isLoadAndPay
    },
    updateIsOfferApplied(isOfferApplied: any) {
      self.isOfferApplied = isOfferApplied
    },
    updateMobileNumber(mobile: string) {
      self.payer.number = mobile
    },
    getUPIIntent: flow(function* getUPIIntent() {
      const upiIntentRequest = getUPIIntentRequest(
        RootStore.merchant.id.toString(),
        RootStore.transaction.amount.payableAmount,
        self.id.intentId,
      )
      try {
        const resp = yield getUPIIntentApi(upiIntentRequest)
        if (resp?.status === 'SUCCESS' && resp?.qr) {
          self.upiIntent = resp?.qr
          return resp
        } else {
          const customError = {
            message: resp?.message ?? errorMessage.defautCatchMessage,
          }
          RootStore.message.setMessage(customError.message, MessageTypes.error)

          throw { message: customError }
        }
      } catch (err) {
        const customError = {
          message: err?.message ?? errorMessage.defautCatchMessage,
        }
        RootStore.message.setMessage(customError.message, MessageTypes.error)

        throw { message: customError }
      }
    }),
    updateIntentStatusApi(callIntentStatusApi: boolean) {
      self.callIntentStatusApi = callIntentStatusApi
    },
  }))
  .views((self) => ({
    getIntegrationType(rUrl: string): any {
      const integrationType = {
        contentType: self.txnMeta?.contentType,
        method: self.txnMeta?.method,
        rUrl: rUrl,
      }
      return integrationType
    },
    getEncodedIntegrationType(): any {
      const integrationType = {
        contentType: self.txnMeta?.contentType,
        method: self.txnMeta?.method,
        rUrl: self?.txnMeta?.returnUrl,
      }
      return encodeURIComponent(JSON.stringify(integrationType))
    },
    getEncodedPayLoad(): any {
      const payLoad = self.txnMeta?.payLoad
      if (!isEmpty(payLoad)) {
        return encodeURIComponent(JSON.stringify(self.txnMeta?.payLoad))
      }
      return payLoad
    },
    getMerchantRedirectingUrl(): any {
      const returnPage = REACT_APP_ENDPOINT
        ? `${REACT_APP_URL}${REACT_APP_ENDPOINT}/transaction/details`
        : `${REACT_APP_URL}/transaction/details`
      const retUrl = self?.initiatingEntity?.returnUrl
      const encodedReturnUrl = encodeURIComponent(retUrl)
      return `${returnPage}?tid=${self?.id?.id}&intentId=${self.id.intentId}&returnUrl=${encodedReturnUrl}`
    },
    getTransactionDataList(): any {
      const listData = [
        { title: 'Transaction ID', value: self.id.id },
        { title: 'Invoice No', value: self.id.invoiceno },
      ]
      return listData
    },
    getSuccessInfoList(isMandate: boolean): any {
      const listData = [
        { title: 'Amount Paid', value: `₹${Number(self.amount.netAmount).toFixed(2)}` },
        { title: 'Paid on', value: convertToDate(self.timestamp) },
      ]
      const mandateListData = [
        { title: 'Amount Paid', value: `₹${Number(self.amount.netAmount).toFixed(2)}` },
        { title: 'Frequency', value: convertToDate(self.mandate.frequency) },
        { title: 'Start Date', value: convertToDate(self.timestamp) },
        { title: 'End Date', value: convertToDate(self.mandate.tillDate) },
      ]
      return isMandate ? mandateListData : listData
    },
  }))
const TransactionInitialData = Transaction.create({
  id: {
    id: '0',
  },
})

export type TransactionType = Instance<typeof Transaction>
export { Transaction, TransactionInitialData }
